import React from "react";

//
import { Card, Row } from "react-bootstrap";
import TitleBox from "../TitleBox";

function Terms() {
  let items = [
    {
      title: "A. Subscriber Only",
      content: "Referral program works if a user is an active subscriber.",
    },
    {
      title: "B. Generate Uniqe URL",
      content:
        "After a user signs up, a unique referral url will be generated.",
    },
    {
      title: "C. Gain from Referaals",
      content: "A user gains 10% money from referrals url that user send.",
    },
    {
      title: "D. Get Paid",
      content:
        "Get paid from his/her referral users’ subscription renewals if he/she is a subscriber.",
    },
    {
      title: "E. Rights of Cancelation",
      content:
        "Referral payments will be done in maximum 30 days cause of user rights of cancelations",
    },
  ];
  return (
    <div className="terms">
      <div className="d-none d-sm-block">
        <TitleBox title="Program Terms" />
      </div>

      <Row>
        {items.map((item, index) => (
          <div className="col-sm-6 col-xl-4 col-xxl item" key={index}>
            <Card className='h-100'>
              <p>{item.title}</p>
              <p>{item.content}</p>
            </Card>
          </div>
        ))}
      </Row>
    </div>
  );
}

export default Terms;
